import { googleMapsScriptUrl } from "./maps/getters";
import useGoogleMapsApi from "./maps/hooks/useGoogleMapsApi";
export default {
  googleMapsScriptUrl: googleMapsScriptUrl,
  useGoogleMapsApi: useGoogleMapsApi
};